import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onScanVin, onViewProfile, onSyncData, lastSyncTime }) => {
  const formatSyncTime = (timestamp) => {
    if (!timestamp) return 'Nie';
    return new Date(timestamp)?.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-4">
      <h3 className="font-semibold mb-3">Schnellaktionen</h3>
      
      <div className="grid grid-cols-2 gap-3 mb-4">
        <Button
          variant="outline"
          onClick={onScanVin}
          className="h-16 flex-col"
          iconName="Scan"
        >
          <span className="text-xs mt-1">VIN Scanner</span>
        </Button>
        
        <Button
          variant="outline"
          onClick={onViewProfile}
          className="h-16 flex-col"
          iconName="User"
        >
          <span className="text-xs mt-1">Profil</span>
        </Button>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="RefreshCw" size={14} className="text-text-secondary" />
          <span className="text-xs text-text-secondary">
            Letzte Sync: {formatSyncTime(lastSyncTime)}
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onSyncData}
          iconName="RefreshCw"
          iconPosition="left"
        >
          Sync
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;